import { Button, LoadingIndicator } from "@light-technology/components";
import { api } from "../../state/api";
import type { AppResponse, Enrollment, Location } from "../../state/api.types";

type SandboxActionsProps = {
  app: AppResponse;
  enrollment: Enrollment;
  location: Location | null | undefined;
};

export const SandboxActions = (props: SandboxActionsProps) => {
  const [deleteEnrollment, deleteEnrollmentResult] =
    api.useDeleteEnrollmentMutation();
  const [processEnrollment, processEnrollmentResult] =
    api.useProcessEnrollmentMutation();
  const [simulateContractExpiring, simulateContractExpiringResult] =
    api.useSimulateContractExpiringMutation();
  const [simulateServiceDrop, simulateServiceDropResult] =
    api.useSimulateServiceDropMutation();

  if (
    deleteEnrollmentResult.isLoading ||
    processEnrollmentResult.isLoading ||
    simulateContractExpiringResult.isLoading ||
    simulateServiceDropResult.isLoading
  ) {
    return <LoadingIndicator type="brand-spinner" />;
  }

  if (props.enrollment.is_service_active) {
    return (
      <div className="flex gap-lg">
        <Button
          size="md"
          color="secondary"
          onClick={() => {
            simulateServiceDrop({
              appUUID: props.app.uuid,
            });
          }}
          data-ph-capture-attribute-action="sandbox-end-service"
        >
          End service
        </Button>
        {/* TODO <Button size="md" color="secondary">Enable renewal offer</Button> */}
        <Button
          size="md"
          color="secondary"
          onClick={() => {
            simulateContractExpiring({
              appUUID: props.app.uuid,
              days_before_expiration: 0,
            });
          }}
          data-ph-capture-attribute-action="sandbox-expire-contract"
        >
          Expire contract
        </Button>
      </div>
    );
  }
  if (props.enrollment.is_enrollment_finalized) {
    return (
      <div className="flex gap-lg">
        <Button
          size="md"
          color="secondary"
          onClick={() => {
            deleteEnrollment({
              appUUID: props.app.uuid,
            });
          }}
          data-ph-capture-attribute-action="sandbox-delete-enrollment"
        >
          Delete enrollment
        </Button>
        {!props.location?.final_service_date && (
          <Button
            size="md"
            color="secondary"
            onClick={() => {
              processEnrollment({
                appUUID: props.app.uuid,
              });
            }}
            data-ph-capture-attribute-action="sandbox-process-enrollment"
          >
            Process enrollment
          </Button>
        )}
      </div>
    );
  }
  return (
    <Button
      size="md"
      color="secondary"
      onClick={() => {
        deleteEnrollment({
          appUUID: props.app.uuid,
        });
      }}
      data-ph-capture-attribute-action="sandbox-clear-enrollment"
    >
      Reset enrollment
    </Button>
  );
};
